import { Injectable } from '@angular/core';
import { City } from '@models/city';
import { Observable, catchError, filter, first, from, of, tap } from 'rxjs';
import { Title } from '@models/title';
import { InsurenetInterfaceService } from './insurenet-interface/insurenet-interface.service';

@Injectable()
export class HelperService {
    private _personTitles: Title[] = [];
    private citiesCache: City[] = [];

    public constructor(private insurenetInterface: InsurenetInterfaceService) {}

    public get personTitles(): Observable<Title[]> {
        if (this._personTitles.length === 0) {
            return this.getPersonTitles();
        } else {
            return of(this._personTitles);
        }
    }

    /**
     * Returns an observable containing a City from cache. If not found, XHRs to get it.
     * So in the component you can subscribe to this and get the value from cache or from
     * LockersNet transparently.
     *
     * @todo Untested, but the idea to use observables seemed so nice ...
     *
     * @param {string} zip
     * @returns {Observable<City>}
     */
    public getCity(zip: string): Observable<City> {
        // emits the City[] as a sequence of City-objects.
        return from(this.citiesCache).pipe(
            // returns the first matching City or throws Error, if stream completes.
            first((city) => city.zip === zip),
            // catches the Error and calls out to LockersNet to get the city and add it to the cache.
            catchError(() =>
                this.insurenetInterface.getCity(zip, { retryCount: 2, notify: 'NONE', spin: false }).pipe(
                    filter((res) => res != null),
                    tap((city: City) => this.citiesCache.push(city)),
                ),
            ),
        );
    }

    private getPersonTitles(): Observable<Title[]> {
        return this.insurenetInterface
            .getTitles({ retryCount: 2, notify: 'NONE', spin: false })
            .pipe(tap((titles) => (this._personTitles = titles)));
    }
}
